import { DEVELOPER_LEVEL_ACCESS } from 'src/components/access';
import { PREOWNED } from 'src/constants/CARTYPE';
import { IMake } from 'src/interfaces/make';
import { IStore } from 'src/interfaces/store';

/**
 * Handles the setup of the makes
 *
 * @param {string} accessLevel
 * @param {IStore[]} stores
 * @param {string} carType
 * @param {IMake[]} makes
 * @return {*}
 */
export const handleSetUpMakes = (
    accessLevel: string,
    stores: IStore[],
    carType: string,
    makes: IMake[]
) => {
    let selectedMakes: IMake[] = [];

    if (accessLevel === DEVELOPER_LEVEL_ACCESS) selectedMakes = makes;
    else {
        if (carType === PREOWNED) selectedMakes = makes;
        else
            stores.map((store) => {
                if (store.make) selectedMakes.push(store.make);
            });
    }
    return selectedMakes;
};
